module.exports = __webpack_public_path__ + "img/usuario2.37726696.png";